import React, { useEffect, useState } from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Line } from 'react-chartjs-2';

import { useFleetAdminController } from 'src/controllers/Dashboard/FleetAdmin/FleetAdminController';
import DashboardCombustivelCards from './DashboardCombustivelCards';
import AlertasFraudeCard from './AlertasFraudeCard';
import PostosCombustivelCard from './PostosCombustivelCard';
import AbastecimentosCard from './AbastecimentosCard';
import { useFinishOrderServiceListController } from 'src/controllers/OrderService/ListFinishOrderServiceControle';
import { Dropdown } from 'primereact/dropdown';
import { dateToString } from 'src/utils/dateToString';

const FleetAdminDashboard: React.FC = () => {
	const { getFleetDashboard, handleFleetDashboard } = useFleetAdminController();
	const { getFinishOrderServiceListController } = useFinishOrderServiceListController();

	const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

	let thisYear = new Date().getFullYear();
	let iterableYears = new Date().getFullYear() - 10;
	let datesArray = [];
	while (iterableYears <= thisYear) {
		datesArray.push(iterableYears);
		iterableYears++;
	}

	const data = {
		labels: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		],
		datasets: [
			{
				label: 'Consumo de Combustível (L)',
				data: getFleetDashboard.fleetDataMonth?.CONSUMO_MES.map((amount) => {
					return amount.CONSUMO_QUANTIDADE;
				}),
				fill: false,
				backgroundColor: 'rgb(54, 162, 235)',
				borderColor: 'rgba(54, 162, 235, 0.2)',
				yAxisID: 'y-axis-1',
			},
			{
				label: 'Consumo de Combustível (R$)',
				data: getFleetDashboard.fleetDataMonth?.CONSUMO_MES.map((value) => {
					return value.CONSUMO_VALOR;
				}),
				fill: false,
				backgroundColor: 'rgb(233, 168, 27)',
				borderColor: 'rgb(255, 182, 99)',
				yAxisID: 'y-axis-2',
			},
		],
	};

	const options = {
		scales: {
			yAxes: [
				{
					type: 'linear',
					display: true,
					position: 'left',
					id: 'y-axis-1',
				},
				{
					type: 'linear',
					display: true,
					position: 'right',
					id: 'y-axis-2',
					gridLines: {
						drawOnArea: false,
					},
				},
			],
		},
	};

	const HEADER_VEICULO = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Veículo</span>
				{rowData.DESCRICAO_VEICULO}
			</React.Fragment>
		);
	};
	const HEADER_PLACA_VEICULO = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Placa</span>
				{rowData.PLACA_VEICULO}
			</React.Fragment>
		);
	};
	const HEADER_DESCRICAO_DEMANDA = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Demanda</span>
				{rowData.DESCRICAO_DEMANDA}
			</React.Fragment>
		);
	};
	const HEADER_VEICULOKM = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Hodômetro</span>
				{rowData.VEICULOKM}
			</React.Fragment>
		);
	};
	const HEADER_DATAEFETIVADA = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Data</span>
				{dateToString(rowData.DATAEFETIVADA, 'br')}
			</React.Fragment>
		);
	};
	const HEADER_TIPOORDEMSERVICO = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Manutenção</span>
				{rowData.DESCRICAO_TIPOORDEMSERVICO}
			</React.Fragment>
		);
	};

	const HEADER_NOME_CONDUTOR = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Nome</span>
				{rowData.NOME}
			</React.Fragment>
		);
	};
	const HEADER_CATEGORIACNH = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Categoria CNH</span>
				{rowData.CATEGORIACNH}
			</React.Fragment>
		);
	};
	const HEADER_VALIDADECNH = (rowData: any) => {
		return (
			<React.Fragment>
				<span className='left-header'>Vencimento</span>
				{dateToString(rowData.VALIDADECNH, 'br')}
			</React.Fragment>
		);
	};

	useEffect(() => {
		const token = getFleetDashboard.generate_token();

		const script = document.createElement('script');
		script.src = `https://mobirota.orbitalsistema.xyz/api/embed?u=5&t=${token}`;
		script.async = true;

		const container = document.getElementById('mobirota-container');

		if (container) {
			container.innerHTML = '';
			container.appendChild(script);
		}
	}, []);

	return (
		/**
		 * Adicionar wrap em textos para evistar que os textos fiquem se sobrepondo
		 */
		<div>
			<div className='card'>
				<h4>Dashboard da Frota</h4>
			</div>
			<DashboardCombustivelCards />
			<AlertasFraudeCard />
			<PostosCombustivelCard />
			<AbastecimentosCard />
			<div className='p-grid p-fluid dashboard'>
				<div className='p-col-12 p-md-4'>
					<div className='card summary'>
						<span className='title'>Veículos</span>
						<span className='detail'>Ativos</span>
						<span className='count visitors'>
							{getFleetDashboard.loading ? (
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							) : (
								getFleetDashboard.fleetData?.QUANTIDADE_VEICULO || 0
							)}
						</span>
					</div>
				</div>
				<div className='p-col-12 p-md-4'>
					<div className='card summary'>
						<span className='title'>Consumo</span>
						<span className='detail'>Combustível</span>
						<span className='count purchases'>
							{getFleetDashboard.loading ? (
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							) : (
								Intl.NumberFormat('pt-BR', {
									style: 'currency',
									currency: 'BRL',
								}).format(getFleetDashboard.fleetData?.CONSUMO.CONSUMO_VALOR || 0)
							)}
						</span>
					</div>
				</div>
				<div className='p-col-12 p-md-4'>
					<div className='card summary'>
						<span className='title'>Manutenções</span>
						<span className='detail'>No último mês</span>
						<span className='count revenue'>
							{getFleetDashboard.loading ? (
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							) : (
								getFleetDashboard.fleetData?.QUANTIDADE_SERVICO || 0
							)}
						</span>
					</div>
				</div>
			</div>

			<div className='p-grid'>
				<div className='p-col-12 p-md-6'>
					<div className='card'>
						<h6>Manutenções finalizadas</h6>

						<DataTable
							className='p-datatable-sm dashboard-table'
							rowHover
							value={getFinishOrderServiceListController.finishOrderServiceData}
							scrollable
							scrollHeight='512px'
							autoLayout>
							<Column field='DESCRICAO_VEICULO' header='Veículo' body={HEADER_VEICULO} />
							<Column field='PLACA_VEICULO' header='Placa' body={HEADER_PLACA_VEICULO} />
							<Column field='DESCRICAO_DEMANDA' header='Demanda' body={HEADER_DESCRICAO_DEMANDA} />
							<Column field='VEICULOKM' header='Hodômetro' body={HEADER_VEICULOKM} />
							<Column field='DATAEFETIVADA' header='Data' body={HEADER_DATAEFETIVADA} />
							<Column
								field='DESCRICAO_TIPOORDEMSERVICO'
								header='Manutenção'
								body={HEADER_TIPOORDEMSERVICO}
							/>
						</DataTable>
						{getFinishOrderServiceListController.loading ? (
							<div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							</div>
						) : (
							<></>
						)}
					</div>
				</div>

				<div className='p-col-12 p-md-6'>
					<div className='card'>
						<h6>CNH próximas do vencimento</h6>

						<DataTable
							className='p-datatable-sm dashboard-table'
							rowHover
							value={getFleetDashboard.fleetData?.CNH}
							scrollable
							scrollHeight='512px'
							autoLayout>
							<Column field='NOME' header='Nome' body={HEADER_NOME_CONDUTOR} />
							<Column field='CATEGORIACNH' header='Categoria CNH' body={HEADER_CATEGORIACNH} />
							<Column field='VALIDADECNH' header='Vencimento' body={HEADER_VALIDADECNH} />
						</DataTable>
						{getFleetDashboard.loading ? (
							<div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '1em' }}></i>
							</div>
						) : (
							<></>
						)}
					</div>
				</div>

				<div className='p-col-12'>
					<div className='card'>
						<div>
							<h4>Resumo</h4>
							<p>Período Selecionado:</p>
							<Dropdown
								id='datas'
								options={datesArray}
								value={currentYear}
								onChange={(e) => {
									handleFleetDashboard.getDashboardMonthData(e.value);
									setCurrentYear(e.value);
								}}
							/>
						</div>

						{getFleetDashboard.loadingMonth ? (
							<div className='p-d-flex p-jc-center p-ai-center p-mt-3 p-mb-3'>
								<i className='pi pi-spin pi-spinner' style={{ fontSize: '2em' }}></i>
							</div>
						) : (
							<Line data={data} options={options} />
						)}
					</div>
				</div>
			</div>
			<div className='card'>
				<div id="mobirota-container"></div>
			</div>
		</div>
	);
};

export default FleetAdminDashboard;
